import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./SubscriptionSuccess.module.css"
import PropTypes from "prop-types";
import BidProPlusBiddingLogo from "../../assets/BidProPlusBiddingHalfLogo.png";
import BidProPlusSeniorityLogo from "../../assets/BidProPlusSeniorityHalfLogo.png";
import BidProPlusTripBoardLogo from "../../assets/BidProPlusTripBoardHalfLogo.png";

const SubscriptionSuccess = ({
  product,
  price,
  cycle,
  formData,
  paymentResponse,
  zip,
  imageSrc,
  onContinue,
}) => {
  const [errorMessage, setErrorMessage] = useState(
    ""
    //"Manage my account is currently undergoing development. Please contact tech@bidpro.com for any questions."
  );
  const [alertType, setAlertType] = useState("danger");

  const navigate = useNavigate();

  const showError = (message, type = "danger") => {
    setErrorMessage(message);
    setAlertType(type);
    setTimeout(() => setErrorMessage(null), 7000);
  };
  const handleManageAccBtnClicked = () => {
    navigate("/account");
  };
  const renderDownloadOptions = () => {
    const downloadOption = (
      title,
      logo,
      webAppLink,
      iosAppLink,
      webOrIOS = "Web"
    ) => (
      <div className="text-center">
        <h5>
          Download the <a href={iosAppLink}>{title}</a> App
        </h5>
        <p>to your iPad or iPhone.</p>
        <img
          src={logo}
          alt={`${title} App`}
          style={{
            width: "100px",
            height: "100px",
            marginBottom: "10px",
          }}
        />
        <p>
          Go to the <a href={webAppLink}>{title}</a> {webOrIOS} App.
        </p>
        <p>Remember to bookmark the page for easy access.</p>
      </div>
    );

    if (product === "Bidding & Seniority") {
      return (
        <div className="d-flex justify-content-center align-items-center flex-wrap flex-md-nowrap">
          <div className="me-3" style={{ minWidth: "200px" }}>
            {downloadOption(
              "Bidder",
              BidProPlusBiddingLogo,
              "https://bidding.bidproplus.com/",
              "https://apps.apple.com/us/app/bidpro-bidding-for-ipa/id1251050627",
              "Web"
            )}
          </div>
          <div
            className="vr mx-3 d-none d-md-block"
            style={{ height: "200px", width: "2px" }}
          ></div>
          <div className="ms-3" style={{ minWidth: "200px" }}>
            {downloadOption(
              "Seniority",
              BidProPlusSeniorityLogo,
              "https://apps.apple.com/us/app/bidpro-seniority-for-ipa/id1527711444",
              "https://apps.apple.com/us/app/bidpro-seniority-for-ipa/id1527711444",
              "IOS"
            )}
          </div>
        </div>
      );
    } else if (product === "BidPro Bundle") {
      return (
        <div className="d-flex justify-content-center align-items-center flex-wrap flex-md-nowrap">
          <div className="me-3" style={{ minWidth: "200px" }}>
            {downloadOption(
              "TripBoard",
              BidProPlusTripBoardLogo,
              "https://tripboard.bidproplus.com/",
              "https://apps.apple.com/us/app/bidpro-tripboard-for-ipa/id1590630416"
            )}
          </div>
          <div
            className="vr mx-3 d-none d-md-block"
            style={{ height: "300px", width: "2px" }}
          ></div>
          <div className="mx-3" style={{ minWidth: "200px" }}>
            {downloadOption(
              "Bidder",
              BidProPlusBiddingLogo,
              "https://bidding.bidproplus.com/",
              "https://apps.apple.com/us/app/bidpro-bidding-for-ipa/id1251050627"
            )}
          </div>
          <div
            className="vr mx-3 d-none d-md-block"
            style={{ height: "300px", width: "2px" }}
          ></div>
          <div className="ms-3" style={{ minWidth: "200px" }}>
            {downloadOption(
              "Seniority",
              BidProPlusSeniorityLogo,
              "https://apps.apple.com/us/app/bidpro-seniority-for-ipa/id1527711444",
              "https://apps.apple.com/us/app/bidpro-seniority-for-ipa/id1527711444",
              "IOS"
            )}
          </div>
        </div>
      );
    } else if (product === "TripBoard") {
      return (
        <div className="d-flex justify-content-center align-items-center">
          {downloadOption(
            "TripBoard",
            BidProPlusTripBoardLogo,
            "https://tripboard.bidproplus.com/",
            "https://apps.apple.com/us/app/bidpro-tripboard-for-ipa/id1590630416"
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="container text-center">
      <h5 className="mb-3 mt-4">Your signup is complete!</h5>
      <p className={styles.header}>
        Payment for your {cycle} {product} was successfully processed.
        <br />
        You are now a BidPro subscriber.
      </p>
      <h5 className={styles.signOff}>Thanks for flying with us!</h5>

      <div className="row justify-content-center">
        {renderDownloadOptions()}
      </div>
      {errorMessage && (
        <div className={`alert alert-${alertType}`} role="alert">
          {errorMessage}
        </div>
      )}

      {
        <button
          style={{
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "20px",
            padding: "10px 20px",
            fontSize: "16px",
            cursor: "pointer",
            marginTop: "30px",
            marginBottom: "30px",
          }}
          //onClick={onContinue}
          onClick={handleManageAccBtnClicked}
        >
          Manage my Account
        </button>
      }
    </div>
  );
};

SubscriptionSuccess.propTypes = {
  product: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  cycle: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  paymentResponse: PropTypes.object.isRequired,
  zip: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
};

export default SubscriptionSuccess;
